import { UserPermissions } from '@centecomm/portal-service';
import BusinessNavigationIcon from 'Icons/NavigationItem/Business';
import React from 'react';
import { Redirect } from 'react-router-dom';
import { FeatureConfiguration } from '../../../Core/Types/FeatureConfiguration';
import companySettingsConfiguration from './CompanySettings/companySettingsConfiguration';
import onboardingFlowConfiguration from './OnBoardingFlow/onboardingFlowConfiguration';
import paymentsConfiguration from './Payments/paymentsConfiguration';
import userConfiguration from './Users/userConfiguration';

const childItems = [userConfiguration, companySettingsConfiguration, onboardingFlowConfiguration, paymentsConfiguration];
const rootRedirection = <Redirect to={childItems[0].navigationItem?.route.url as Required<string>} />;

const companyConfiguration: FeatureConfiguration = {
    name: 'administrationFeature:company.title',
    navigationItem: {
        route: {
            text: 'administrationFeature:sidebar.company.title',
            url: '/company-settings',
            Icon: BusinessNavigationIcon,
            ownerOperatorRoot: rootRedirection,
            tenantRoot: rootRedirection,
            childItems,
        },
        isGloballyAccessible: false,
        permissions: [UserPermissions.ManageAdminConfig, UserPermissions.ViewUsers],
    },
    disableFeature: [],
};

export default companyConfiguration;
